
export enum ImageSource {
  Camera = 'CAMERA',
  Photos = 'PHOTOS',
}